//  src/pages/Register.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import axios from "axios";

export default function Register() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", name: "", organization: "", role: "viewer" });
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const registerUser = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/users/register/`, {
        ...form,
        user_timezone: "America/Vancouver"
      });
      navigate("/login");
    } catch (err) {
      alert("Registration failed");
    }
  };

  return (
    <div className="bg-gradient-to-br from-white to-gray-50 text-gray-900 font-sans min-h-screen flex flex-col">
      {/* Header */}
      <header className="flex items-center justify-between px-6 py-4 border-b bg-white shadow-sm sticky top-0 z-50">
        <a href="https://viewmax.net">
          <img src="/images/viewmax_logo.png" alt="Viewmax Logo" className="h-10 object-contain" />
        </a>
        <div className="relative">
          <button onClick={() => setDropdownOpen(!dropdownOpen)} className="flex items-center gap-1 border px-4 py-2 rounded hover:bg-gray-100 transition">
            <FiMenu />
          </button>
          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white border rounded shadow-lg z-10 text-left">
              <a href="https://viewmax.net" className="block px-4 py-2 hover:bg-gray-100">Home</a>
              <a href="https://viewmax.net/contact" className="block px-4 py-2 hover:bg-gray-100">Contact</a>
              <a href="https://viewmax.net/about-us/" className="block px-4 py-2 hover:bg-gray-100">About Us</a>
              <a href="https://viewmax.net/our-services" className="block px-4 py-2 hover:bg-gray-100">Our Services</a>
              <a href="https://viewmax.net/faq" className="block px-4 py-2 hover:bg-gray-100">FAQs</a>
            </div>
          )}
        </div>
      </header>

      {/* Main */}
      <main className="flex-grow flex items-center justify-center">
        <form onSubmit={registerUser} className="bg-white p-6 rounded shadow-md space-y-4 w-80 mt-12">
          <h2 className="text-2xl font-bold">Register</h2>
          <input type="text" placeholder="Full Name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full p-2 border rounded" />
          <input type="text" placeholder="Organization" value={form.organization} onChange={e => setForm({ ...form, organization: e.target.value })} className="w-full p-2 border rounded" />
          <input type="email" placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="w-full p-2 border rounded" />
          <input type="password" placeholder="Password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className="w-full p-2 border rounded" />
          <button type="submit" className="w-full bg-green-600 text-white p-2 rounded">Register</button>
        </form>
      </main>

      {/* Footer */}
      <footer className="text-sm text-gray-500 text-center py-8 border-t border-gray-200 bg-white">
        © {new Date().getFullYear()} Viewmax Inc. All rights reserved.
      </footer>
    </div>
  );
}

